import { useMemo } from "react";
import { useAppSelector } from "../../framework/redux/hooks";
import { makeSelectSalaryPeriodByDate } from "../../framework/redux/slices/salaryPeriodSlice";

export const useSelectSalaryPeriodByDate = (date: string) => {
    const state = useAppSelector((state) => state.salaryPeriod);

    const selectSalaryPeriodByDate = useMemo(makeSelectSalaryPeriodByDate, []);
    return selectSalaryPeriodByDate(state, date);
};
